import { State } from '@meraki-internal/state';

export class NavigationMenuState extends State<{isOpen: boolean}> {
    constructor() {
        super({
            isOpen: false,
        });
    };

    setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });
    };

    isOpen = () => {
        return Boolean(this.state?.isOpen);
    };
}
